import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import { request, METHOD } from '@/utils/request';
import axios from 'axios';
import Cookie from 'js-cookie';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;
export function queryMyApplyList(_x) {
  return _queryMyApplyList.apply(this, arguments);
}
function _queryMyApplyList() {
  _queryMyApplyList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, request('/myApply/queryMyApplyList', METHOD.POST, data));
      }
    }, _callee);
  }));
  return _queryMyApplyList.apply(this, arguments);
}
export function queryMyApplyFormList(_x2) {
  return _queryMyApplyFormList.apply(this, arguments);
}
function _queryMyApplyFormList() {
  _queryMyApplyFormList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, request('/myApply/queryMyApplyFormList', METHOD.POST, data));
      }
    }, _callee2);
  }));
  return _queryMyApplyFormList.apply(this, arguments);
}
export function saveCorrelationForm(_x3) {
  return _saveCorrelationForm.apply(this, arguments);
}
function _saveCorrelationForm() {
  _saveCorrelationForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, request('/myApply/saveCorrelationForm', METHOD.POST, data));
      }
    }, _callee3);
  }));
  return _saveCorrelationForm.apply(this, arguments);
}
export function queryCorrelationFormList(_x4) {
  return _queryCorrelationFormList.apply(this, arguments);
}
function _queryCorrelationFormList() {
  _queryCorrelationFormList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, request('/myApply/queryCorrelationFormList', METHOD.POST, data));
      }
    }, _callee4);
  }));
  return _queryCorrelationFormList.apply(this, arguments);
}
export function getFormCate() {
  return _getFormCate.apply(this, arguments);
}
function _getFormCate() {
  _getFormCate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, request('/form/getFormCate', METHOD.POST, {}));
      }
    }, _callee5);
  }));
  return _getFormCate.apply(this, arguments);
}
export function getMyApplyDetailsById(_x5) {
  return _getMyApplyDetailsById.apply(this, arguments);
}
function _getMyApplyDetailsById() {
  _getMyApplyDetailsById = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(data) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          return _context6.a(2, request('/myApply/getMyApplyDetailsById', METHOD.POST, data));
      }
    }, _callee6);
  }));
  return _getMyApplyDetailsById.apply(this, arguments);
}
export function editMyApplyDetailsById(_x6) {
  return _editMyApplyDetailsById.apply(this, arguments);
}
function _editMyApplyDetailsById() {
  _editMyApplyDetailsById = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(data) {
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          return _context7.a(2, request('/myApply/editMyApplyDetailsById', METHOD.POST, data));
      }
    }, _callee7);
  }));
  return _editMyApplyDetailsById.apply(this, arguments);
}
export function startProcess(_x7) {
  return _startProcess.apply(this, arguments);
}
function _startProcess() {
  _startProcess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(data) {
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          return _context8.a(2, request('/flowable/definition/start', METHOD.POST, data));
      }
    }, _callee8);
  }));
  return _startProcess.apply(this, arguments);
}
export function deletFormFillById(_x8) {
  return _deletFormFillById.apply(this, arguments);
}
function _deletFormFillById() {
  _deletFormFillById = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(data) {
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          return _context9.a(2, request('/form/deletFormFillById', METHOD.POST, data));
      }
    }, _callee9);
  }));
  return _deletFormFillById.apply(this, arguments);
}
export function queryMyBelowApplyList(_x9) {
  return _queryMyBelowApplyList.apply(this, arguments);
}
function _queryMyBelowApplyList() {
  _queryMyBelowApplyList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(data) {
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          return _context0.a(2, request('/myApply/queryMyBelowApplyList', METHOD.POST, data));
      }
    }, _callee0);
  }));
  return _queryMyBelowApplyList.apply(this, arguments);
}
export function queryMyBelowApplyOverList(_x0) {
  return _queryMyBelowApplyOverList.apply(this, arguments);
}
function _queryMyBelowApplyOverList() {
  _queryMyBelowApplyOverList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(data) {
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          return _context1.a(2, request('/myApply/queryMyBelowApplyOverList', METHOD.POST, data));
      }
    }, _callee1);
  }));
  return _queryMyBelowApplyOverList.apply(this, arguments);
}
export function getUserInfo(_x1) {
  return _getUserInfo.apply(this, arguments);
}
function _getUserInfo() {
  _getUserInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(data) {
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.n) {
        case 0:
          return _context10.a(2, request('/myApply/getUserInfo', METHOD.POST, {}));
      }
    }, _callee10);
  }));
  return _getUserInfo.apply(this, arguments);
}
export function saveTask(_x10) {
  return _saveTask.apply(this, arguments);
}
function _saveTask() {
  _saveTask = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(data) {
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          return _context11.a(2, request('/myApply/saveTask', METHOD.POST, data));
      }
    }, _callee11);
  }));
  return _saveTask.apply(this, arguments);
}
export function handleNotice(_x11) {
  return _handleNotice.apply(this, arguments);
}
function _handleNotice() {
  _handleNotice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(data) {
    return _regenerator().w(function (_context12) {
      while (1) switch (_context12.n) {
        case 0:
          return _context12.a(2, request('/myApply/handleNotice', METHOD.POST, data));
      }
    }, _callee12);
  }));
  return _handleNotice.apply(this, arguments);
}
export function handleFormApplyOver(_x12) {
  return _handleFormApplyOver.apply(this, arguments);
}
function _handleFormApplyOver() {
  _handleFormApplyOver = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(data) {
    return _regenerator().w(function (_context13) {
      while (1) switch (_context13.n) {
        case 0:
          return _context13.a(2, request('/myApply/handleFormApplyOver', METHOD.POST, data));
      }
    }, _callee13);
  }));
  return _handleFormApplyOver.apply(this, arguments);
}
export function getFormTask(_x13) {
  return _getFormTask.apply(this, arguments);
}
function _getFormTask() {
  _getFormTask = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(data) {
    return _regenerator().w(function (_context14) {
      while (1) switch (_context14.n) {
        case 0:
          return _context14.a(2, request('/myApply/getFormTask', METHOD.POST, data));
      }
    }, _callee14);
  }));
  return _getFormTask.apply(this, arguments);
}
export function exportApplyForm(_x14) {
  return _exportApplyForm.apply(this, arguments);
}
function _exportApplyForm() {
  _exportApplyForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(data) {
    var token, url;
    return _regenerator().w(function (_context15) {
      while (1) switch (_context15.n) {
        case 0:
          token = Cookie.get('Authorization');
          url = "".concat(BASE_URL, "/myApply/exportApplyForm");
          return _context15.a(2, fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': token
            },
            responseType: 'blob',
            body: JSON.stringify(data)
          }));
      }
    }, _callee15);
  }));
  return _exportApplyForm.apply(this, arguments);
}
export default {
  queryMyApplyList: queryMyApplyList,
  getFormCate: getFormCate,
  getMyApplyDetailsById: getMyApplyDetailsById,
  editMyApplyDetailsById: editMyApplyDetailsById,
  startProcess: startProcess,
  deletFormFillById: deletFormFillById,
  queryMyBelowApplyList: queryMyBelowApplyList,
  queryMyBelowApplyOverList: queryMyBelowApplyOverList,
  getUserInfo: getUserInfo,
  saveTask: saveTask,
  queryMyApplyFormList: queryMyApplyFormList,
  exportApplyForm: exportApplyForm
};